var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsDate, IsEnum, IsNotEmpty, IsObject, IsOptional, IsString } from "class-validator";
import { Type } from "class-transformer";
import { UserType } from "healthex-common/user.dtos";
import { ConsentType } from "./consent.dtos";
export var EventCategory;
(function (EventCategory) {
    EventCategory["PATIENT_DIRECTED_DATA_EXCHANGE"] = "PATIENT_DIRECTED_DATA_EXCHANGE";
    EventCategory["DATA_AUTHORIZATION"] = "DATA_AUTHORIZATION";
    EventCategory["PREREAD_FLOW"] = "PREREAD_FLOW";
    EventCategory["CONSENT"] = "CONSENT";
    EventCategory["VIDEO"] = "VIDEO";
    EventCategory["SCREEN"] = "SCREEN";
})(EventCategory || (EventCategory = {}));
export var EnrollmentDecision;
(function (EnrollmentDecision) {
    EnrollmentDecision["CONSENTED"] = "CONSENTED";
    EnrollmentDecision["DECLINED"] = "DECLINED";
    EnrollmentDecision["INTERESTED"] = "INTERESTED";
})(EnrollmentDecision || (EnrollmentDecision = {}));
export var PatientDirectedDataAccessDecision;
(function (PatientDirectedDataAccessDecision) {
    PatientDirectedDataAccessDecision["CONSENTED"] = "CONSENTED";
    PatientDirectedDataAccessDecision["DECLINED"] = "DECLINED";
    PatientDirectedDataAccessDecision["INTERESTED"] = "INTERESTED";
})(PatientDirectedDataAccessDecision || (PatientDirectedDataAccessDecision = {}));
export var EnrollmentFlowType;
(function (EnrollmentFlowType) {
    EnrollmentFlowType["SELF_SERVE"] = "SELF_SERVE";
    EnrollmentFlowType["GUIDED"] = "GUIDED";
})(EnrollmentFlowType || (EnrollmentFlowType = {}));
export const CategoryActions = {
    [EventCategory.PATIENT_DIRECTED_DATA_EXCHANGE]: ["SENT", "OPEN", "RECORD_RETRIEVED", "COMPLETE"],
    [EventCategory.DATA_AUTHORIZATION]: ["SENT", "OPEN", "COMPLETE"],
    [EventCategory.PREREAD_FLOW]: ["SENT", "OPEN", "SAVE_AND_EXIT", "COMPLETE"],
    [EventCategory.CONSENT]: ["CONSENTED", "DECLINED", "INTERESTED"],
    [EventCategory.VIDEO]: ["PLAY", "PAUSE", "COMPLETE", "ENDED"],
    [EventCategory.SCREEN]: ["ENTER", "LEAVE"],
};
export class BaseEventMetadata {
}
__decorate([
    IsOptional(),
    IsEnum([UserType, "PROVIDER"]),
    __metadata("design:type", String)
], BaseEventMetadata.prototype, "userType", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], BaseEventMetadata.prototype, "userId", void 0);
export class EnrollmentEventMetadata extends BaseEventMetadata {
}
__decorate([
    IsOptional(),
    IsString({ each: true }),
    __metadata("design:type", Array)
], EnrollmentEventMetadata.prototype, "targetPatients", void 0);
__decorate([
    IsOptional(),
    IsEnum(EnrollmentFlowType),
    __metadata("design:type", String)
], EnrollmentEventMetadata.prototype, "flowType", void 0);
__decorate([
    IsOptional(),
    IsEnum(EnrollmentDecision),
    __metadata("design:type", String)
], EnrollmentEventMetadata.prototype, "decision", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], EnrollmentEventMetadata.prototype, "page", void 0);
export class PrereadEventMetadata extends BaseEventMetadata {
}
__decorate([
    IsOptional(),
    IsString({ each: true }),
    __metadata("design:type", Array)
], PrereadEventMetadata.prototype, "targetPatients", void 0);
export class VideoEventMetadata extends BaseEventMetadata {
}
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], VideoEventMetadata.prototype, "videoUrl", void 0);
export class EventDto {
}
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], EventDto.prototype, "organizationId", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], EventDto.prototype, "studyId", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], EventDto.prototype, "actorId", void 0);
__decorate([
    IsEnum(EventCategory),
    __metadata("design:type", String)
], EventDto.prototype, "category", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventDto.prototype, "action", void 0);
__decorate([
    IsOptional(),
    IsObject(),
    __metadata("design:type", BaseEventMetadata)
], EventDto.prototype, "metadata", void 0);
export class DateRangeDto {
}
__decorate([
    IsOptional(),
    IsDate(),
    Type(() => Date),
    __metadata("design:type", Date)
], DateRangeDto.prototype, "startDate", void 0);
__decorate([
    IsDate(),
    IsOptional(),
    Type(() => Date),
    __metadata("design:type", Date)
], DateRangeDto.prototype, "endDate", void 0);
export function mapConsentTypeToEventCategory(consentType) {
    var _a;
    const mapping = {
        [ConsentType.PATIENT_DIRECTED_DATA_EXCHANGE]: EventCategory.PATIENT_DIRECTED_DATA_EXCHANGE,
        [ConsentType.DATA_AUTHORIZATION]: EventCategory.DATA_AUTHORIZATION,
    };
    return (_a = mapping[consentType]) !== null && _a !== void 0 ? _a : EventCategory.PATIENT_DIRECTED_DATA_EXCHANGE;
}
